import { render, staticRenderFns } from "./DocumentLabelModal.vue?vue&type=template&id=74d8d55a"
import script from "./DocumentLabelModal.vue?vue&type=script&lang=js"
export * from "./DocumentLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports